import {
  autocompleteClasses,
  Box,
  Button,
  Chip,
  InputBase,
} from "@mui/material";
import React, { FC, useState, useEffect } from "react";
import {
  DatePickerComponent,
  DatePickerInput,
  DatePickerRenderInput,
} from "../../../Components/date-picker.component";
import {
  DropdownInput,
  IOption,
} from "../../../Components/dropdown-input-component";
import ModalComponent from "../../../Components/modal.component";
import InputTextField from "../../../Components/text-field.component";
import styles from "./AddLeads.module.scss";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { PrimaryButton } from "../../../Components/primary-button.component";
import { DefaultButton } from "../../../Components/default-button.component";
import { ContactService } from "../../../Services/contact.service";
import { GetAllDto } from "../../../Shared/dto/get-all-dto";
import Leads from "../Leads.lazy";
import {
  LeadClass,
  LeadModel,
  leadValidationSchema,
} from "../../../Models/lead.model";
import { SourceOfPromotions } from "../../../Shared/consts/source-of-promotion";
import { LeadService } from "../../../Services/leads.service";
import { useNavigate, useParams } from "react-router-dom";
import { ProjectService } from "../../../Services/project.service";
import removeItem from "../../../assets/images/remove-item.svg";
import { useLoading } from "../../../Shared/services/loading-context";
import { PageHeading } from "../../../Components/page-heading.component";
import backButtonImg from "../../../assets/images/back.svg";
import { useSnackbar } from "notistack";
import { FlatModal } from "../../../Components/flat-selection";
import { ContactModal } from "../../../Components/select-contact";
import { FormikConsumer, useFormik } from "formik";
import * as yup from "yup";
import { AddNewContactModal } from "../../../Components/add-new-contact";

interface AddLeadsProps {}
const AddLeads: FC<AddLeadsProps> = () => {
  const [isFlatSelectionModalOpen, setIsFlatSelectionModalOpen] =
    useState<any>(false);
  const [isCustomerModalOpen, setIsCustomerModalOpen] =
    useState<boolean>(false);
  const [isLeadOwnerModalOpen, setIsLeadOwnerModalOpen] =
    useState<boolean>(false);
  const [contactName, setContactName] = useState<any[]>([]);
  const [leadOwner, setLeadOwner] = useState<any[]>([]);
  const [leads, setLeads] = useState<LeadModel>(new LeadClass());
  const [towerData, setTowerData] = useState<any[]>([]);
  const [floorData, setFloorData] = useState<any[]>([]);
  const [flatData, setFlatData] = useState<any[]>([]);
  const [blockNumbers, setBlockNumber] = useState<any[]>([]);
  const [getBlocKNo, setGetBLockNo] = useState<any[]>([]);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const [isAddNewContactModal, setIsAddNewContactModal] =useState<boolean>(false);

  // const [towerToggle, setTowerToggle] = useState<Boolean>(true);
  // const [floorToggle, setFloorToggle] = useState<Boolean>(false);
  // const [flatToggle, setFlatToggle] = useState<Boolean>(false);

  const [modalSelectionNumber, setModalSelectionNumber] = useState<number>(1);

  const leadStatus: IOption[] = [
    { key: 1, value: "Opportunity", text: "Opportunity" },
    { key: 2, value: "Customer", text: "Customer" },
    { key: 3, value: "Prospect", text: "Prospect" },
    { key: 4, value: "Disqualified", text: "Disqualified" },
    { key: 5, value: "Invalid", text: "Invalid" },
  ];

  const style = {
    border: "none",
    width: "560px",
    height: "612px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
  };

  const customerModalStyle = {
    border: "none",
    width: "430px",
    height: "469px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
    padding: 0,
    overflow: "auto",
  };

  const leadOwnerModalStyle = {
    border: "none",
    width: "430px",
    height: "469px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
    padding: 0,
    overflow: "auto",
  };

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#9D9D9D",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: "auto",
      },
    },
  }));

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    background: "#FFFFFF",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "213px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "213px",
      float: "right",
      borderRadius: "10px",
      height: "40px",
    },
  }));

  const contactModal = async () => {
    setIsCustomerModalOpen(true);
    const getAllDto = new GetAllDto("name");
    setLoading(true);
    const response = await ContactService.getContactsForModal(getAllDto);
    setLoading(false);
    if (response.success) {
      setContactName(response.data);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  const leadModal = async () => {
    setIsLeadOwnerModalOpen(true);
    const getAllDto = new GetAllDto("name");
    setLoading(true);
    const response = await ContactService.getContactsForModal(getAllDto);
    setLoading(false);
    if (response.success) {
      setLeadOwner(response.data);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  const getContactData = (currElem: any) => {
    formik.setFieldValue("contactName", currElem.name);
    setIsCustomerModalOpen(false);
    leads.contactId = currElem.id;
    leads.contactName = currElem.name;
  };

  const sendDataToLeadOwner = (currElem: any) => {
    setIsLeadOwnerModalOpen(false);
    leads.contactId = currElem.id;
    leads.contactName = currElem.name;
  };

  const navigate = useNavigate();

  const sendData = async () => {
    const data = { ...leads };
    data.flats = blockNumbers.map((item: any) => item.id);
    delete data.contact;
    setLoading(true);
    const response = await LeadService.save(data);
    setLoading(false);
    if (response.success) {
      navigate("/leads");
      enqueueSnackbar(response.message, { variant: "success" });
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  const validationSchema = yup.object(leadValidationSchema);

  const formik = useFormik({
    initialValues: new LeadClass(),
    validationSchema: validationSchema,
    onSubmit: sendData,
  });

  const leadsFields = (e: any) => {
    formik.handleChange(e);
    const fieldData: any = leads;
    fieldData[e.target.name] = e.target.value;
    setLeads({ ...fieldData });
  };

  const getTowerData = async () => {
    setIsFlatSelectionModalOpen(true);
  };

  const getFloorData = async (id: any) => {
    setModalSelectionNumber(2);
    setLoading(true);
    const response = await ProjectService.floorData(id);
    setLoading(false);
    if (response.success) {
      setFloorData(response.data);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  const closeFlatSelectionModal = () => {
    setIsFlatSelectionModalOpen(false);
    setTowerData([]);
    setFloorData([]);
    setFlatData([]);
  };

  const getBlockNumber = (currElem: any) => {
    setIsFlatSelectionModalOpen(false);
    setModalSelectionNumber(1);
    setBlockNumber((prevState) => [...prevState, currElem]);
  };

  const removeBlockNumber = (id: any) => {
    blockNumbers.splice(id, 1);
    setBlockNumber([...blockNumbers]);
  };

  const { id } = useParams();

  const getDataById = async (id: any) => {
    setLoading(true);
    const response = await LeadService.getById(id);
    setLoading(false);

    if (response.success) {
      setLeads(response.data);
      const data = { ...response.data };
      data.contactName = data.contact?.name;
      formik.setValues({ ...data });
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };
  const redirectToContact = () => {    
    setIsCustomerModalOpen(false);
    setIsAddNewContactModal(true);
  };
  const handleOnClose=()=>{
    setIsAddNewContactModal(false)
  }
  useEffect(() => {
    if (id) getDataById(id);
  }, []);

  const getFlatNumber = (data: any) => {
    setBlockNumber((prevState) => [...prevState, data]);
    setIsFlatSelectionModalOpen(false);
  };

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <PageHeading
          title="Leads"
          // subTitle="Leads/Add Lead"
          hasBackButton={true}
          hasFilter={false}
        />

        <FlatModal
          isFlatModalOpen={isFlatSelectionModalOpen}
          getTowerData={getFlatNumber}
        />

        <ContactModal
          isCustomerModalOpen={isCustomerModalOpen}
          onSelectCustomer={getContactData}
          redirectToContact={redirectToContact}
        />
        <AddNewContactModal

          isAddNewContactModalOpen={isAddNewContactModal}
          onSelectCustomer={getContactData}
          onClose={handleOnClose}
        />

        <Box className="addleads-first-box">
          <InputTextField
            onClick={contactModal}
            label={"Select customer"}
            disabled
            value={
              formik.values.contactName ??
              leads.contactName ??
              leads.contact?.name ??
              ""
            }
            onChange={(e) => {
              leadsFields(e);
            }}
            helperText={formik.touched.contactName && formik.errors.contactName}
            error={
              formik.touched.contactName && Boolean(formik.errors.contactName)
            }
          />

          <DatePickerComponent
            key={"Inquiry date"}
            label="Inquiry date"
            inputFormat="dd/MM/yyyy"
            value={formik.values.leadDate ?? leads.leadDate ?? ""}
            onChange={(e: any) => {
              leadsFields({ target: { name: "leadDate", value: e } });
            }}
            error={formik.touched.leadDate && Boolean(formik.errors.leadDate)}
            helperText={formik.touched.leadDate && formik.errors.leadDate}
          />

          <DatePickerComponent
            key={new Date().getTime() + "one"}
            label="Follow up date"
            inputFormat="dd/MM/yyyy"
            value={leads.followUpDate ?? ""}
            onChange={(e: any) => {
              leadsFields({ target: { name: "followUpDate", value: e } });
            }}
            error={
              formik.touched.followUpDate && Boolean(formik.errors.followUpDate)
            }
            helperText={
              formik.touched.followUpDate && formik.errors.followUpDate
            }
          />

          <DatePickerComponent
            key={new Date().getTime() + "two"}
            label="Site visit date"
            inputFormat="dd/MM/yyyy"
            value={leads.siteVisitDate ?? ""}
            onChange={(e: any) => {
              leadsFields({ target: { name: "siteVisitDate", value: e } });
            }}
            error={
              formik.touched.siteVisitDate &&
              Boolean(formik.errors.siteVisitDate)
            }
            helperText={
              formik.touched.siteVisitDate && formik.errors.siteVisitDate
            }
          />
        </Box>

        <Box className="addleads-second-box">
          <span className="addleads-leadstatus">
            <DropdownInput
              label="Source of promotion"
              options={SourceOfPromotions}
              value={
                formik.values.sourceOfPromotion ?? leads.sourceOfPromotion ?? ""
              }
              name="sourceOfPromotion"
              onChange={(e) => {
                leadsFields(e);
              }}
              helperText={
                formik.touched.sourceOfPromotion &&
                formik.errors.sourceOfPromotion
              }
              error={
                formik.touched.sourceOfPromotion &&
                Boolean(formik.errors.sourceOfPromotion)
              }
            />
          </span>

          <InputTextField
            className="addleads-lead-owner"
            label="Lead Owner"
            name="leadOwner"
            value={formik.values.leadOwner ?? leads.leadOwner ?? ""}
            onChange={(e) => {
              leadsFields(e);
            }}
            helperText={formik.touched.leadOwner && formik.errors.leadOwner}
            error={formik.touched.leadOwner && Boolean(formik.errors.leadOwner)}
          />

          <span className="addleads-leadstatus">
            <DropdownInput
              label="Lead status"
              name="leadStage"
              options={leadStatus}
              value={leads.leadStage ?? ""}
              onChange={(e) => {
                leadsFields(e);
              }}
            />
          </span>

          <InputTextField
            name="sourceCampaign"
            className="addleads-lead-owner"
            label="Source campaign"
            value={leads.sourceCampaign ?? ""}
            onChange={(e) => {
              leadsFields(e);
            }}
          />

          <InputTextField
            name="salesPerson"
            value={leads.salesPerson ?? ""}
            className="addleads-lead-owner"
            onChange={(e) => {
              leadsFields(e);
            }}
            label="Sales person"
          />

          <InputTextField
            name="notes"
            value={leads.notes ?? ""}
            className="addleads-lead-owner"
            onChange={(e) => {
              leadsFields(e);
            }}
            label="Notes"
          />
        </Box>

        <Box className="addleads-third-box">
          {blockNumbers.map((currElem: any, index: any) => {
            return (
              <span key={currElem.id}>
                <Button
                  onChange={(e) => {
                    leadsFields(e);
                  }}
                  onClick={() => {}}
                  className="addleads-property-btn"
                >
                  {currElem?.blockNumber}
                  <img
                    className="leads-remove-image"
                    onClick={() => removeBlockNumber(index)}
                    src={removeItem}
                  />
                </Button>
              </span>
            );
          })}

          <Button onClick={getTowerData} className="addleads-property-btn">
            Flat Selection
          </Button>
        </Box>

        <Box className="addlead-save-box">
          <div className="addlead-save-btn">
            <PrimaryButton className="leads-primary-btn" type="submit">
              Save
            </PrimaryButton>
          </div>
        </Box>

        <ModalComponent
          // title="Select Customer"
          style={leadOwnerModalStyle}
          isModalOpen={isLeadOwnerModalOpen}
          customHeader={true}
          hideModal={() => setIsLeadOwnerModalOpen(false)}
        >
          <div className="selection-modal">
            <span className="selectCustomerText">Select Customer</span>
            <DefaultButton>Add New Customer </DefaultButton>
          </div>
          <Search className="modalSearch">
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search here"
              inputProps={{ "aria-label": "search" }}
            />
          </Search>

          {leadOwner.map((currElem) => {
  return (
    <Box
      key={currElem.id || currElem.mobileNo || currElem.name} // ✅ Add this line
      onClick={() => sendDataToLeadOwner(currElem)}
      className="d-flex justify-content-between"
      sx={{
        margin: "auto 20px",
        marginTop: "15px",
        padding: "16px 20px",
        border: "2px solid #E8E8E8",
        position: "relative",
        cursor: "pointer",
        borderRadius: "10px",
      }}
    >
      <span className="modalListName">{currElem.name}</span>
      <span className="modalListNumber">{currElem.mobileNo}</span>
    </Box>
  );
})}

        </ModalComponent>
      </form>
    </div>
  );
};

export default AddLeads;

//  <ModalComponent
//    // title="Select Customer"
//    style={style}
//    title="Flat Selection"
//    isModalOpen={isFlatSelectionModalOpen}
//    customHeader={false}
//    hideModal={closeFlatSelectionModal}
//  >
//    <div className="selection-modal">
//      {/* <span className="selectCustomerText">Select Customer</span> */}
//      {/* <DefaultButton>Add New Customer </DefaultButton> */}
//    </div>
//    <Search className="modalSearch">
//      <SearchIconWrapper>
//        <SearchIcon />
//      </SearchIconWrapper>
//      <StyledInputBase
//        placeholder="Search here"
//        inputProps={{ "aria-label": "search" }}
//      />
//    </Search>

//    {modalSelectionNumber == 1 ? (
//      <>
//        <div className="flat-selection" key="flat-selection-tower-header">
//          <DefaultButton
//            className="back-button"
//            onClick={closeFlatSelectionModal}
//          >
//            <img src={backButtonImg} alt="Back Button" />
//          </DefaultButton>
//          <span className="addleads-flatselection-modal-text">Select Tower</span>
//        </div>
//        <Box
//          className="addleads-flatselection-modal-box"
//          key="flat-selection-tower-box"
//        >
//          {towerData.map((currElem) => {
//            return (
//              <Chip
//                key={`tower-${currElem.tower}`}
//                className="addleads-modal-chip"
//                label={currElem.tower}
//                onClick={() => {
//                  getFloorData(currElem.id);
//                }}
//              />
//            );
//          })}
//        </Box>
//      </>
//    ) : (
//      <></>
//    )}

//    {modalSelectionNumber == 2 ? (
//      <>
//        <div className="flat-selection" key="flat-selection-floor-header">
//          <DefaultButton
//            onClick={() => setModalSelectionNumber(1)}
//            className="back-button"
//          >
//            <img src={backButtonImg} alt="Back Button" />
//          </DefaultButton>
//          <span className="addleads-flatselection-modal-text">Select Floor</span>
//        </div>
//        <Box
//          className="addleads-flatselection-modal-box"
//          key="flat-selection-floor-box"
//        >
//          {floorData.map((currElem) => {
//            return (
//              <Chip
//                key={`floor-${currElem.floorNumber}`}
//                className="addleads-modal-chip"
//                label={currElem.floorNumber}
//                onClick={() => {
//                  getFlatData(currElem.id);
//                }}
//              />
//            );
//          })}
//        </Box>
//      </>
//    ) : (
//      <></>
//    )}

//    {modalSelectionNumber == 3 ? (
//      <>
//        <div className="flat-selection" key="flat-selection-block-number-header">
//          <DefaultButton
//            onClick={() => setModalSelectionNumber(2)}
//            className="back-button"
//          >
//            <img src={backButtonImg} alt="Back Button" />
//          </DefaultButton>
//          <span className="addleads-flatselection-modal-text">
//            Select Block Number
//          </span>
//        </div>
//        <Box
//          className="addleads-flatselection-modal-box"
//          key="flat-selection-block-number-box"
//        >
//          {flatData.map((currElem, index) => {
//            return (
//              <Chip
//                key={`block-${currElem.blockNumber}`}
//                className="addleads-modal-chip"
//                label={currElem.blockNumber}
//                onClick={() => {
//                  getBlockNumber(currElem);
//                }}
//              />
//            );
//          })}
//        </Box>
//      </>
//    ) : (
//      <></>
//    )}
//  </ModalComponent>;

//  <ModalComponent
//    style={customerModalStyle}
//    isModalOpen={isCustomerModalOpen}
//    customHeader={true}
//    hideModal={() => setIsCustomerModalOpen(false)}
//  >
//    <div className="selection-modal">
//      <span className="selectCustomerText">Select Customer</span>
//      <DefaultButton>Add New Customer </DefaultButton>
//    </div>
//    <Search className="modalSearch">
//      <SearchIconWrapper>
//        <SearchIcon />
//      </SearchIconWrapper>
//      <StyledInputBase
//        placeholder="Search here"
//        inputProps={{ "aria-label": "search" }}
//      />
//    </Search>

//    {contactName.map((currElem) => {
//      return (
//        <Box
//          // onMouseDown={onRippleStart}
//          // onMouseUp={onRippleStop}
//          onClick={() => sendDataToSelectCustomer(currElem)}
//          className="d-flex justify-content-between"
//          sx={{
//            margin: "auto 20px",
//            marginTop: "15px",
//            padding: "16px 20px",
//            border: "2px solid #E8E8E8",
//            position: "relative",
//            cursor: "pointer",
//            borderRadius: "10px",
//          }}
//        >
//          {/* <TouchRipple ref={rippleRef} center={false} /> */}

//          <span className="modalListName">{currElem.name}</span>
//          <span className="modalListNumber">{currElem.mobileNo}</span>
//        </Box>
//      );
//    })}
//  </ModalComponent>;
